import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { createWidget } from 'actions/editor';
import { fetchPaletteFolders, fetchComponentsForPalette, fetchComponentsForPaletteFolder, } from 'actions/palette';

import _ from 'lodash';
import cx from 'classnames';
import { Tab, Nav } from 'react-bootstrap';
import { IKImage } from 'imagekitio-react';
import { createMixpanelEvent } from 'actions/mixpanel';
import { MIXPANEL_WIDGET_USED } from 'constants/mixpanelEvents';
import { getStoryboardMixpanelEventPayload } from 'services/mixpanelUtil';
import StoryboardContext from 'components/Storyboard/context';
import { PaletteContext } from '.';
import { getPositionForNewWidget } from 'components/Editor/helper/layoutManager';

import styles from './palette.module.scss';
import { HTML, IFRAME } from 'constants/widgetTypes';
import { BrandkitEmptyMessageCard, FolderPaletteComponentsView, MultiwidgetPaletteComponentsView } from './multiWidgetFolderPalette';
import { ShortLoader } from 'components/ApplicationLoader';

export const EmbedPalette = ({ editorSession, defaultParent }) => {
  const paletteContext = React.useContext(PaletteContext);

  const { palettes = [] } = paletteContext;

  const paletteData = palettes.find(item => item.type === 'EMBED');
  const defaultId = _.get(paletteData, 'defaultId', null);
  const brandkitId = _.get(paletteData, 'brandkitId', null);

  return (
    <Tab.Pane eventKey="EMBED" className={cx(styles.tabPane, styles.embedPalette)}>
      <EmbedWidgetPaletteFolders
        editorSession={editorSession}
        defaultParent={defaultParent}
        defaultPaletteId={defaultId}
        paletteId={brandkitId}
        type={'default'}
        paletteData={paletteData}
        typeName={'EMBED ELEMENTS'}
      />
    </Tab.Pane>
  )
}

const EmbedPaletteView = ({ editorSession, defaultParent, paletteId, type, folderId }) => {
  const storyboardContext = React.useContext(StoryboardContext);
  const dispatch = useDispatch();
  const paletteContext = React.useContext(PaletteContext);

  const parentWidget = useSelector(state => {
    const widgets = _.get(state, `${editorSession}.present.widgets`) || []
    return widgets.find(widget => {
      return widget.uid === defaultParent
    });
  });

  const desktopParentLayout = _.get(parentWidget, `properties.desktop.layout`);
  const mobileParentLayout = _.get(parentWidget, `properties.mobile.layout`);

  const components = useSelector(state => { return _.get(state, `palette.[${type}][${paletteId}].items`) || [] })
  const loading = useSelector(state => { return _.get(state, `palette.[${type}][${paletteId}].loading`) || false })
  const fetched = useSelector(state => { return _.get(state, `palette.[${type}][${paletteId}].fetched`) || false })
  const pagination = useSelector(state => { return _.get(state, `palette.[${type}][${paletteId}].pagination`) || {} })
  const hasMoreItems = _.get(pagination, "currentPage") < _.get(pagination, "totalPages") - 1;

  // useEffect(() => {
  //   if (paletteId && !fetched) {
  //     handleComponentsForPalette(0);
  //   }
  // }, [paletteId]);

  const handleComponentsForPalette = (page) => {
    var request = {
      sort: 'order',
      order: 'ASC',
      widgetResponse: false
    }
    dispatch(fetchComponentsForPalette(paletteId, type, request, page, 50));
  }

  const loadMore = () => {
    const nextPage = pagination.currentPage + 1;
    if (nextPage >= pagination.totalPages) {
      return;
    }
    handleComponentsForPalette(nextPage);
  }

  const handleCreateHtmlWidget = (widgetType, iframe, content) => {
    const formatString = (value) => {
      if (value) {
        value = value.replace(/_/g, " ");
  
        value = value
          .toLowerCase()
          .split(" ")
          .map(word => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" ");
      }
      return value;
    };
    const desktopPosition = getPositionForNewWidget(editorSession, desktopParentLayout, { width: 700, height: 260 });
    const mobilePosition = getPositionForNewWidget(editorSession, mobileParentLayout, { width: 260, height: 260 });

    dispatch(
      createWidget(
        editorSession,
        [
          {
            type: widgetType,
            name: "HTML",
            properties: {
              "desktop": {
                "visible": true,
                "layout": {
                  "transform": {
                    "translate": `${desktopPosition.x}px, ${desktopPosition.y}px`,
                    "rotate": "0deg"
                  },
                  "width": "700px",
                  "height": "260px"
                },
                "iframe": iframe
              },
              "mobile": {
                "visible": true,
                "layout": {
                  "transform": {
                    "translate": `${mobilePosition.x}px, ${mobilePosition.y}px`,
                    "rotate": "0deg"
                  },
                  "width": "260px",
                  "height": "260px"
                },
                "iframe": iframe
              }
            },
            content: content
          }
        ],
        defaultParent
      )
    );
    var mixpanelPayload = getStoryboardMixpanelEventPayload(storyboardContext.id, storyboardContext.name, storyboardContext.type);
    mixpanelPayload = {
      ...mixpanelPayload,
      widget_type: 'Embed Elements',
      brandkit_widget: false,
    }
    dispatch(createMixpanelEvent(MIXPANEL_WIDGET_USED, mixpanelPayload))
    paletteContext.close();
  }

  return (
    <div className={styles.defaultWidgets} id={folderId}>
      <div className={cx(styles.widget, styles.embed)} onClick={() => handleCreateHtmlWidget(IFRAME, false, null)}>
        <i className={cx('cleverstory-content', styles.icon)}></i>
        <div className={styles.details}>
          <h5>Embed a site</h5>
          <p>Embed a website URL</p>
        </div>
      </div>
      <div className={cx(styles.widget, styles.embed)} onClick={() => handleCreateHtmlWidget(HTML, true, null)} >
        <i className={cx('cleverstory-embed-iframe', styles.icon)}></i>
        <div className={styles.details}>
          <h5>Embed HTML</h5>
          <p>Embed a custom code within an iFrame</p>
        </div>
      </div>
      <div className={cx(styles.widget, styles.embed)} onClick={() => handleCreateHtmlWidget(HTML, false, null)} >
        <i className={cx('cleverstory-Embed', styles.icon)}></i>
        <div className={styles.details}>
          <h5>Embed HTML without iframe </h5>
          <p>Embed HTML code without an iFrame directly to your page</p>
        </div>
      </div>
    </div>
  );
}


export const EmbedWidgetPaletteFolders = ({ editorSession, defaultParent, defaultPaletteId, paletteId, type, paletteData, typeName }) => {
  const dispatch = useDispatch();
  const iconPaletteRef = React.useRef(null);

  const folders = useSelector(state => _.get(state, `palette.brandkit[${paletteId}].folders.items`, []));
  const defaultFolders = useSelector(state => _.get(state, `palette.default[${defaultPaletteId}].folders.items`, []));

  const fetched = useSelector(state => _.get(state, `palette.brandkit[${paletteId}].folders.fetched`, false));
  const fetchedDefault = useSelector(state => _.get(state, `palette.default[${defaultPaletteId}].folders.fetched`, false));

  const components = useSelector(state => { return _.get(state, `palette.default[${paletteId}].items`) || [] });
  const brandKitComponents = useSelector(state => { return _.get(state, `palette.brandkit[${paletteId}].items`) || [] });

  const workspace = useSelector((state) => _.get(state, "workspaces.workspace.item"));
  const brandkitEnabled = _.get(workspace, 'brandkitEnabled', false);
  const showDefault = _.get(paletteData, 'showDefault', false) || !brandkitEnabled;

  const showOtherBrandkitFolder = brandKitComponents.length > 0 || components.length > 0;

  const showEmptyMessage = components.length == 0 && !showDefault && folders.length == 0;

  useEffect(() => {
    if (paletteId && !fetched) {
      dispatch(fetchPaletteFolders(paletteId, 'brandkit'));
      handleComponentsForPalette(0);
    }
  }, [paletteId]);

  useEffect(() => {
    if (defaultPaletteId && !fetchedDefault) {
      dispatch(fetchPaletteFolders(defaultPaletteId, 'default'));
      handleComponentsForPalette(0);
    }
  }, [defaultPaletteId]);

  const handleComponentsForPalette = (page) => {
    var request = {
      sort: 'order',
      order: 'ASC',
      widgetResponse: false
    }
    dispatch(fetchComponentsForPalette(paletteId, type, request, page, 50));
  }

  const handleFolderSelect = (folder) => {
    const folderElement = document.getElementById(folder);
    if (folderElement) {
      folderElement.scrollIntoView({ behavior: 'smooth' });
    }
  }

  if(!fetchedDefault || !fetched) return (
    <div className={styles.paletteLoaderContainer}>
      <ShortLoader className={styles.paletteLoaderContainer}/>
    </div>
  );

  return (
    <>
    { showEmptyMessage && 
      <BrandkitEmptyMessageCard/>
    }

    { !showEmptyMessage && 
      <div className={styles.iconManagement}>
        <div className={styles.iconFolders}>
          <Nav variant="pills" className={styles.iconManagementTab}>

          {brandkitEnabled && (folders.length>0 || showOtherBrandkitFolder) && 
            <>
              <div className={styles.headerTitle}>{`BRAND ${typeName}`}</div>
              {folders.map(folder => {
                return (
                  <Nav.Item key={folder.id} onClick={() => { handleFolderSelect(folder.id) }}>
                    <Nav.Link eventKey={folder.id}>{folder.name}</Nav.Link>
                  </Nav.Item>
                )
              })}

              {showOtherBrandkitFolder && 
                <Nav.Item key={'embedOtherFolder'} onClick={() => { handleFolderSelect('embedOtherFolder') }}>
                <Nav.Link eventKey={'embedOtherFolder'}>Other</Nav.Link>
              </Nav.Item>
              }
              <hr />
            </>
          }

          {showDefault && 
              <>
                <div className={styles.headerTitle}>CLEVERSTORY</div>
                {defaultFolders.map(folder => {
                  return (
                    <Nav.Item key={folder.id} onClick={() => { handleFolderSelect(folder.id) }}>
                      <Nav.Link eventKey={folder.id}>{folder.name}</Nav.Link>
                    </Nav.Item>
                  )
                })}

                {!_.includes(['ASSET GRIDS'], typeName) && 
                  <Nav.Item key={'embedDefaultFolder'} onClick={() => { handleFolderSelect('embedDefaultFolder') }}>
                    <Nav.Link eventKey={'embedDefaultFolder'}>Default</Nav.Link>
                  </Nav.Item>
                }
            </>
          }
          </Nav>
        </div>

        <div className={styles.iconContent} ref={iconPaletteRef}>
          {brandkitEnabled && (folders.length>0 || showOtherBrandkitFolder) &&
            <>
              <div className={cx(styles.paletteTitle, styles.shapeTitle)}>
                <h3 className={styles.label}>{`BRAND ${typeName}`}</h3>
                <hr className={styles.labelHighliter} />
              </div>

              {folders.map(folder => {
                return (
                  <FolderPaletteComponentsView
                    key={folder.id}
                    editorSession={editorSession}
                    defaultParent={defaultParent}
                    paletteId={paletteId}
                    folder={folder}
                    type={type}
                    typeName={typeName}
                  />
                )
              })}

              {showOtherBrandkitFolder &&
                <MultiwidgetPaletteComponentsView editorSession={editorSession}
                defaultParent={defaultParent}
                paletteId={paletteId}
                type={'brandkit'}  
                typeName={typeName}
                folderName={'Other'}
                folderId={'embedOtherFolder'}
                />
              }
              
              </>
          }

          {showDefault && 
            <>
              <div className={cx(styles.paletteTitle, styles.shapeTitle)}>
                <h3 className={styles.label}>CLEVERSTORY</h3>
                <hr className={styles.labelHighliter} />
              </div>
            
              {defaultFolders.map(folder => {
                return (
                  <FolderPaletteComponentsView
                    key={folder.id}
                    editorSession={editorSession}
                    defaultParent={defaultParent}
                    paletteId={defaultPaletteId}
                    folder={folder}
                    type={type}
                    typeName={typeName}
                  />
                )
              })}

              <EmbedPaletteView
                editorSession={editorSession}
                defaultParent={defaultParent}
                paletteId={defaultPaletteId}
                type={'default'}
                folderId={'embedDefaultFolder'}
              />
            </>
          }

        </div>
      </div>
    }
    </>
  )
}